export default __webpack_public_path__ + "static/media/autobet-invite.bbd0f708.svg";